module.exports = function noParamsRequired(val) {
  return val !== undefined
}
